import React from "react";

interface Props {
  className?: string;
}

const Copy: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.62504 0.583008H2.62504C1.98337 0.583008 1.45837 1.10801 1.45837 1.74967V9.91634H2.62504V1.74967H9.62504V0.583008ZM11.375 2.91634H4.95837C4.31671 2.91634 3.79171 3.44134 3.79171 4.08301V12.2497C3.79171 12.8913 4.31671 13.4163 4.95837 13.4163H11.375C12.0167 13.4163 12.5417 12.8913 12.5417 12.2497V4.08301C12.5417 3.44134 12.0167 2.91634 11.375 2.91634ZM11.375 12.2497H4.95837V4.08301H11.375V12.2497Z"
        fill="var(--icon)"
      />
    </svg>
  );
};

export default Copy;
